import React from 'react';

export default function SubscriptionCheckoutSuccess() {
  return (
    <div className="checkout-success-container" style={{padding: '20px', textAlign: 'center'}}>
      <div>
        <div style={{fontSize: '48px', color: '#28a745', marginBottom: '20px'}}>✓</div>
        <h2 style={{color: '#28a745', marginBottom: '20px'}}>Subscription Active</h2>
        <p style={{fontSize: '16px', color: '#6c757d', marginBottom: '30px'}}>
          Thank you for subscribing. Your subscription has been activated. You may need to refresh the page for your
          plan to appear in your account.
        </p>
      </div>
    </div>
  );
}
